import { RootState } from '../../store';
import PersonInterface from '../../types/PersonInterface';

export const getPersonByID = ( id: PersonInterface['id']) => ( state: RootState ): PersonInterface | undefined => {
  return state.people.data.find( person => person.id === id );
};
